import { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';
export const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export function useAnalyticsData(path, query = '', refresh = 0) {
  const [state, setState] = useState({ data: null, loading: true, error: '' });
  useEffect(() => {
    const controller = new AbortController();
    let timedOut = false;
    setState({ data: null, loading: true, error: '' });
    const timeout = setTimeout(() => { timedOut = true; controller.abort(); setState({ data: null, loading: false, error: 'The request timed out. Please retry.' }); }, 30000);
    fetch(`${API_BASE}/api/dashboard/${path}${query ? `?${query}` : ''}`, { signal: controller.signal, headers: authHeaders() })
      .then(async (response) => {
        if (!response.ok) throw new Error(response.status === 404 ? 'This view is not available on the connected server yet.' : `Could not load data (HTTP ${response.status}).`);
        return response.json();
      })
      .then((data) => { if (!controller.signal.aborted) setState({ data, loading: false, error: '' }); })
      .catch((error) => { if (!controller.signal.aborted && !timedOut) setState({ data: null, loading: false, error: error.message }); })
      .finally(() => clearTimeout(timeout));
    return () => { clearTimeout(timeout); controller.abort(); };
  }, [path, query, refresh]);
  return state;
}
